import { Link } from 'react-router-dom';
import { getCategoryImage } from '../../utils/imageHelpers';
import { useTranslation } from 'react-i18next';
import { getLocalized } from '../../utils/i18nHelpers';
import { SlideUp, StaggerContainer, StaggerItem } from '../animations';

const CategoryGrid = ({ categories }) => {
    const { i18n, t } = useTranslation();
    if (!categories || categories.length === 0) return null;

    // Use placeholder images to match the design aesthetic if the category doesn't have a specific elegant image.
    const elegantPlaceholders = [
        "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?auto=format&fit=crop&w=800&q=80",
        "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?auto=format&fit=crop&w=800&q=80",
        "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=800&q=80",
        "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=800&q=80",
        "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?auto=format&fit=crop&w=800&q=80",
        "https://images.unsplash.com/photo-1573408301145-b98c4af05b8a?auto=format&fit=crop&w=800&q=80",
    ];

    return (
        <section className="py-16 md:py-24 px-4 md:px-6 lg:px-12 bg-white">
            <div className="max-w-[1400px] mx-auto">
                {/* Header Area */}
                <SlideUp className="text-center mb-16">
                    <span className="block text-[#287968] text-[11px] font-bold tracking-[0.25em] uppercase mb-4">{t('home.category.subtitle')}</span>
                    <h2 className="text-4xl md:text-5xl font-serif text-[#4a4a4a] mb-6">
                        {t('nav.shopByCategory') || 'Kategorilere Göre Alışveriş'}
                    </h2>
                    <div className="w-12 h-[1px] bg-gray-300 mx-auto"></div>
                </SlideUp>

                {/* Grid */}
                <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                    {categories.slice(0, 6).map((category, index) => {
                        const categoryName = getLocalized(category, 'name', i18n.language) || category.name;
                        const imageUrl = category.image ? getCategoryImage(category.image) : elegantPlaceholders[index % elegantPlaceholders.length];
                        
                        return (
                            <StaggerItem key={category._id} className="h-full">
                            <Link
                                to={`/products?category=${category.slug}`}
                                className="group relative block aspect-[4/5] md:aspect-[4/3] overflow-hidden bg-gray-100"
                            >
                                <img
                                    src={imageUrl}
                                    alt={categoryName}
                                    loading="lazy"
                                    decoding="async"
                                    className="w-full h-full object-cover transition-transform duration-[2000ms] group-hover:scale-105"
                                />

                                {/* Gradient overlay for text readability */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80" />

                                {/* Text Content */}
                                <div className="absolute bottom-6 left-6 right-6">
                                    <span className="block text-white/70 text-[9px] tracking-[0.2em] uppercase font-semibold mb-1">
                                        {categoryName} {t('home.category.collection')}
                                    </span>
                                    <h3 className="text-white text-base md:text-lg tracking-widest font-bold uppercase">
                                        {categoryName}
                                    </h3>
                                </div>
                            </Link>
                            </StaggerItem>
                        );
                    })}
                </StaggerContainer>
            </div>
        </section>
    );
};

export default CategoryGrid;
